export default "__VITE_ASSET__BDkf59Ib__"